<template>
  <div>
    <h2 class="my-1" v-if="$store.getters.hasStarted">Les challenges</h2>
    <h2 class="my-1" v-else>A venir</h2>
    <div class="d-flex flex-column ga-2" v-if="$store.state.loading">
      <v-skeleton-loader class="gradient" type="list-item" height="36"></v-skeleton-loader>
      <v-skeleton-loader class="gradient" type="list-item" height="36"></v-skeleton-loader>
    </div>

    <div class="d-flex flex-column ga-2" v-else>
      <v-btn @click="onSelectChallenge('12_boucles')" color="grey-lighten-2"
        :class="[$store.state.selected_challenge == '12_boucles' ? 'gradient text-white' : '']" block>12 boucles</v-btn>
      <v-btn @click="onSelectChallenge('12_boucles_relai')" color="grey-lighten-2"
        :class="[$store.state.selected_challenge == '12_boucles_relai' ? 'gradient text-white' : '']" block>12 boucles
        relai</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onSelectChallenge(challenge) {
      this.$store.commit("setSelectedLoop", 0);
      this.$store.commit("setSelectedChallenge", challenge);
      this.$router.push({ name: "ChallengeView", params: { challenge_uuid: challenge } });
    },
  },
};
</script>

<style lang="scss" scoped></style>